import { getDefaultFields } from "../../jsons/common/common.fields";
import { twdClass } from "../../constants/tailwind.constants";
import RenderElements from "../form/RenderElements";
import { Button, BtnStyle, BtnBack, BtnEdit} from "../ui/com_ui";
import { cloneDeep, findIndex, find } from "lodash";

export const BlockStylePanel = ({
  currentBlock={},
  setActivePanel,
  updateElementValue,
}) => {
  const {configs={}} = currentBlock
  const list = getDefaultFields({
    type: "TEXT",
    updateTo: `styleProps`,
    fields: ["backgroundcolor", "padding", "margin", "backgroundimage", "backgroundgradient"],
  });
  const overlay = getDefaultFields({
    type: "TEXT",
    updateTo: `overlay.styleProps`,
    fields: ["backgroundcolor", "backgroundimage", "backgroundgradient", "opacity"],
  });
  const container = getDefaultFields({
    type: "TEXT",
    updateTo: "containerStyleProps",
    fields: [
      "backgroundcolor",
      "borderwidth",
      "bordercolor",
      "borderradius",
      "shadow",
      "padding",
      "margin",
      "maxwidth"
    ],
  });
  const columns = getDefaultFields({
    type: "TEXT",
    updateTo: `cardConfig.perRow`,
    fields: ["columns"],
  });

  const bg_section = { inputType: "section", label: "Bacground Style" }
  const overlay_section = { inputType: "section", label: "Overlay Style" }
  const container_section = { inputType: "section", label: "Container Style" }
  let list2=[]
  if (configs.type && configs.type=='table'){
    list2=[ bg_section, ...list, overlay_section, ...overlay, container_section, ...container]
  }else{
    list2=[...columns, bg_section, ...list, overlay_section, ...overlay, container_section, ...container]
  }
  return (
    <StylePanel {...{
      list:list2,
      label:'Section',
      //elementLabel:element.label? element.label : element.text,
      data:currentBlock,
      updateElementValue,
      onBack:()=>{setActivePanel("main")}
    }}/>
  )   
};

export const CardStylePanel = ({
  setActivePanel,
  updateElementValue,
  currentBlock,
}) => {
  const list = getDefaultFields({
    type: "TEXT",
    updateTo: `cardConfig.cardstyleProps`,
    fields: [
      "backgroundcolor",
      "padding",
      "margin",
      "borderwidth",
      "borderradius",
      "bordercolor",
      "shadow",
    ],
  });

  return (
    <StylePanel {...{
      list,
      label:'Card',
      //elementLabel:element.label? element.label : element.text,
      data:currentBlock,
      updateElementValue,
      onBack:()=>{setActivePanel("designcard")}
    }}/>
  )     
};
export const TableStylePanel = ({
  setActivePanel,
  updateElementValue,
  currentBlock,
}) => {
  const list = getDefaultFields({
    type: "TEXT",
    updateTo: `cardConfig.tablestyleProps`,
    fields: [
      "backgroundcolor",
      "padding",
      "margin",
      "borderwidth",
      "borderradius",
      "bordercolor",
      "shadow",
    ],
  });
  const th_section = { inputType: "section", label: "Table Header Style" }
  const th_list = getDefaultFields({
    type: "TEXT",
    updateTo: `cardConfig.tableTHStyleProps`,
    fields: [
      "color",
      "fontsize",
      "textalign",
      "fontweight",
      "fontfamily",
      "white-space",
      "backgroundcolor",
      "padding",
      "margin",
      "borderwidth",
      "borderradius",
      "bordercolor",
    ],
  });

  const td_section = { inputType: "section", label: "Table Data Style" }
  const td_list = getDefaultFields({
    type: "TEXT",
    updateTo: `cardConfig.tableTDStyleProps`,
    fields: [
      "color",
      "fontsize",
      "textalign",
      "fontweight",
      "fontfamily",
      "backgroundcolor",
      "padding",
      "margin",
      "borderwidth",
      "borderradius",
      "bordercolor",
    ],
  });

  return (
    <StylePanel {...{
      list:[...list, th_section, ...th_list, td_section, ...td_list],
      label:'Table',
      //elementLabel:element.label? element.label : element.text,
      data:currentBlock,
      updateElementValue,
      onBack:()=>{setActivePanel("designtable")}
    }}/>
  )   
};

export const TableColStylePanel = ({
  activeColId,
  activeEleId,
  setActivePanel,
  updateElementValue,
  currentBlock={},
}) => {
  const {table={}} = currentBlock
  const {columns=[]} = table
  const indexColumn = findIndex(columns, ["id", activeColId]);
  const column = find(columns, ["id", activeColId]);
  const list = getDefaultFields({
    type: "TEXT",
    updateTo: `table.columns[${indexColumn}].styleProps`,
    fields: [
      "fontsize",
      "textalign",
      "fontweight",
      "fontfamily",
      "white-space",
      "backgroundcolor",
      "borderwidth",
      "borderradius",
      "bordercolor",
      "color",
      "padding",
      "margin",
      "display",
      "flexdirection",
      "justifycontent",
      "flexwrap",
      "alignitems",
      "shadow",
      "opacity",
      "maxwidth"
    ],
  });

  //const bg_section = { inputType: "section", label: "Bacground Style" }
  return (
    <StylePanel {...{
      list,
      label:'Column',
      elementLabel:column.label? column.label : indexColumn,
      data:currentBlock,
      updateElementValue,
      onBack:()=>{setActivePanel("designtable")}
    }}/>
  )  
};
export const TableEleStylePanel = ({
  activeColId,
  activeEleId,
  setActivePanel,
  updateElementValue,
  currentBlock={},
}) => {
  const {table={}} = currentBlock
  const {columns=[]} = table
  const indexColumn = findIndex(columns, ["id", activeColId]);
  const indexElement = findIndex(columns[indexColumn].elements, ["id", activeEleId]);
  const element = find(columns[indexColumn].elements, ["id", activeEleId]);
  let list = getDefaultFields({
    type: "TEXT",
    updateTo: `table.columns[${indexColumn}].elements[${indexElement}].styleProps`,
    fields: [
      "fontsize",
      "textalign",
      "fontweight",
      "fontfamily",
      "white-space",
      "backgroundcolor",
      "borderwidth",
      "borderradius",
      "bordercolor",
      "color",
      "padding",
      "margin",
      "display",
      "flexwrap",
      "alignitems",
      "shadow",
      "opacity",
      "maxwidth"
    ],
  });

  const tag = getDefaultFields({
    type: "TEXT",
    updateTo: `table.columns[${indexColumn}].elements[${indexElement}].tagstyleProps`,
    fields: [
      "fontsize",
      "textalign",
      "fontweight",
      "fontfamily",
      "white-space",
      "backgroundcolor",
      "borderwidth",
      "borderradius",
      "bordercolor",
      "color",
      "padding",
      "margin",      
      "shadow",
      "opacity",
      "maxwidth"
    ],
  });

  if(element.type=='tags'){
    const tag_section = { inputType: "section", label: "Tag Style" }
    list=[
      ...list,
      tag_section,
      ...tag
    ]
  }

  //const bg_section = { inputType: "section", label: "Bacground Style" }
  return (
    <StylePanel {...{
      list,
      label:'Element',
      elementLabel:element.label? element.label : element.text,
      data:currentBlock,
      updateElementValue,
      onBack:()=>{setActivePanel("designtable")}
    }}/>
  )  
};

export const StylePanel = ({
  list,
  label='', 
  data,
  elementLabel='',
  updateElementValue,
  onBack=()=>{}
}) => { 

  return (
    <div className={twdClass("px-3")}>
      <div className={twdClass("py-3 flex items-center")}>
        <BtnBack
          className={"mr-4"}
          onClick={() => onBack()}
        >
          <img alt="" src="/assets/images/icon_arrow_left.png" />
        </BtnBack>
        <div className={twdClass("flex-grow")}>
          <div className={twdClass("text-gray-800 text-sm font-semibold")}>
            {label} {elementLabel && <span className={twdClass("bg-primary-500 px-1 py-1 rounded-lg")}>{elementLabel}</span>} Styles
          </div>
        </div>
      </div>
      <div>
        {[...list].map((item) => (
          <div  className={twdClass("mb-1")}>
            <RenderElements
              element={item}
              data={data}
              updateElementValue={updateElementValue}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
